import { FACEBOOK_CONNECTED_TOGGLE } from "types/actions/facebookConnectedDialog"

export const toggleFacebookConnected = () => {
  return {
    type: FACEBOOK_CONNECTED_TOGGLE
  }
}



// WEBPACK FOOTER //
// ./src/actions/facebookConnectedDialog.js